<template>
    <div>
        <kgr-notice-box>
            <template #headline>
                {{ $t('Diese Funktion ist inaktiv') }}
            </template>
            <template #body>
                <br />
                {{ $t('Sie wollen die Mitarbeiterzeiterfassung testen? Bitte setzen Sie sich mit unserem freundlichen Support-Team in Verbindung.') }}
                <br />
                <div
                    v-if="canRequest"
                    class="kgr-text--rightAligned"
                >
                    <br />
                    <kgr-button

                        :disabled="sent"
                        :value="$t('Anfrage senden')"
                        :pending="sending"
                        @click="triggerEmail"
                    />
                </div>
            </template>
        </kgr-notice-box>
    </div>
</template>

<script>
import Error from '../../js/model/Error';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import NoticeBox from '../../components/common/NoticeBox.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-notice-box': NoticeBox,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
        canRequest: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            sent: false,
            sending: false,
            error: new Error(),
        };
    },
    methods: {
        triggerEmail() {
            this.sending = true;
            axios.post(`/kindergartens/${this.kindergartenId}/employees/time-management/request`, {
            }).then (() => {
                this.$notify.success('Die E-Mail wurde versendet.');
                this.sent = true;
            }).catch(() => {
                this.$notify.error('saveChanges.error');
            }).finally(() => {
                this.sending = false;
            });
        },
    },
};
</script>

<style scoped>

</style>
